import _ from 'lodash';
import template from './featuredProduct.html';

class FeaturedProductComponent {
    /*@ngInject*/
    constructor(catalogService) {
        this.catalogService = catalogService;
    }

    $onInit() {
        this.catalogService.getAllProducts().then((productResponse) => {
            this.product = _.find(productResponse.data, { id: this.productId });
        });
    }

    showProductImage(product) {
        return (product == null || product.images) ? false : true;
    }

    getIsBuyable(product) {
        return (product == null || product.isBuyable) ? true : false;
    }

    getProductDescription(product) {
        const descriptions = _.find(_.get(product, 'descriptions', undefined), { reviewType: 'QuickReview' });
        if (!_.isNil(descriptions)) {
            return _.find(product.descriptions, { reviewType: 'QuickReview' }).value.replace(/<(.|\n)*?>/g, '').replace(/&quot;/g, '"');
        }
    }
}

export default {
    template: template,
    bindings: {
        productId: '<',
        isLoading: '&'
    },
    controller: FeaturedProductComponent
};